import {whitelabelling as Whitelabelling} from 'whitelabelling';

export const CompleteGroupStepController = [
    '$scope', 'RegistrationService',
    function($scope, RegistrationService) {
        $scope.groupName = 'What to expect!';
        $scope.withHero = true; // should we show a hero section
        $scope.autoAdvance = false; // if true, next-step button is auto-clicked
        $scope.finalStep = 0; // the last step number of this group
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/complete.html';

        $scope.whitelabelling = Whitelabelling;

        $scope.EXPECT_PAGE_EXPERT = 'expert';
        $scope.EXPECT_PAGE_BOTH_NO_BOOK = 'both_no_book';
        $scope.EXPECT_PAGE_BOTH_BOOK = 'both_book';
        $scope.EXPECT_PAGE_CONSUMER_NO_BOOK = 'consumer_no_book';
        $scope.EXPECT_PAGE_CONSUMER_BOOK = 'consumer_no_book';

        $scope.showThanks = function() {
            return $scope.registrationData.primaryRole === 'expert' || $scope.registrationData.primaryRole === 'both';
        };

        // we determine which what to expect page to show based on their role and whether they booked a consult
        if ($scope.registrationData.get('primaryRole') === 'expert') {
            $scope.expectPage = $scope.EXPECT_PAGE_EXPERT;
        } else if ($scope.registrationData.get('primaryRole') === 'consumer') {
            if ($scope.registrationData.get('bookedAMeeting')) {
                // they already saw a what to expect after they booked a meeting
                // @see book.js
                RegistrationService.registrationComplete();
            }
            $scope.expectPage = $scope.EXPECT_PAGE_CONSUMER_NO_BOOK;
        } else if ($scope.registrationData.get('bookedAMeeting')) {
            $scope.expectPage = $scope.EXPECT_PAGE_BOTH_BOOK;
        } else {
            // must be a BOTH with no booking
            $scope.expectPage = $scope.EXPECT_PAGE_BOTH_NO_BOOK;
        }

        $scope.registrationComplete = function() {
            RegistrationService.registrationComplete();
        };
    },
];
